import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogBase, OneWayAvailability } from 't4core';
import * as moment from 'moment';

@Component({
    selector: 't4-NearbyOneWayAvailabilityDialog',
    templateUrl: 'NearbyOneWayAvailabilityDialog.html',
    styleUrls: ['./style.css'],
})
export class NearbyOneWayAvailabilityDialog extends DialogBase implements OnInit {
    public availability: OneWayAvailability[] = [];
    public selectedLocationId: number;
    public selectedTypeId: number;
  public hasChanged: boolean = false;

  public showAllLocations: boolean = false;

  private locationId: number = 0;
  private referenceTime: moment.Moment = moment();
    private isWebBooking: boolean = false;

    constructor(public dialogRef: MatDialogRef<NearbyOneWayAvailabilityDialog>, @Inject(MAT_DIALOG_DATA) public data: any) {
        super("NearbyOneWayAvailabilityDialog");

      if (data.locationId) this.locationId = data.locationId;
      if (data.referenceTime) this.referenceTime = data.referenceTime;
        if (data.selectedLocationId) this.selectedLocationId = data.selectedLocationId;
        if (data.selectedTypeId) this.selectedTypeId = data.selectedTypeId;
      if (data.isWebBooking) this.isWebBooking = data.isWebBooking;
      if (data.showAllLocations) this.showAllLocations = data.showAllLocations;
    }


    ngOnInit(): void {
        this.loadInfo();
    }

    private async loadInfo() {
        var token = this.beginLoad("TUrbo.Core.NearbyOneWayAvailabilityDialog.msgLoading", "Checking availability", null);
        this.availability = await this.Api.get<OneWayAvailability[]>("Rental/GetNearbyOneWayAvailability", { referenceLocationId: this.locationId, referenceTime: this.referenceTime, showEmpty: this.showAllLocations });
        this.endLoad(token);
    }

    public selectOption(opt: OneWayAvailability, typeId: number) {
        this.selectedLocationId = opt.LocationId;
        this.selectedTypeId = typeId;

        this.hasChanged = true;
    }

    public async close() {
        if(this.isWebBooking)
            await this.UI.alert("TUrbo.Core.NearbyOneWayAvailabilityDialog.headChangeNote", "Byte av station/storlek", "TUrbo.Core.NearbyOneWayAvailabilityDialog.msgChangeNote", "Notera att priset kan uppdateras vid förändringen om bokningen är gjort på webben. Kontrollera priset och informera kunden.");

        this.dialogRef.close({ locationId: this.selectedLocationId, typeId: this.selectedTypeId });
    }
}
